import {FlowchartEdge} from './processFlowchartConfigEditorConstants';

export function isNewEdgeDuplicate(edges: Array<FlowchartEdge>, newEdge: FlowchartEdge): boolean {
  return edges.some(
    (e) =>
      e.source === newEdge.source &&
      e.target === newEdge.target &&
      e.sourceHandle === newEdge.sourceHandle &&
      e.targetHandle === newEdge.targetHandle &&
      e.type === newEdge.type
  );
}
